module.exports = __webpack_public_path__ + "img/no-intention.59411e93.png";